import * as React from 'react';
import { MotivationPopupMobile } from '../../components/MotivationPopup';
import { useMotivationPopup } from './hooks/useMotivationPopup';

export const MotivationPopupMobileContainer: React.VFC = () => {
  const { isVisible, handleClose } = useMotivationPopup();

  return <MotivationPopupMobile isVisible={isVisible} onClose={handleClose} />;
};
